export const PLATFORM = "";
export const SITE = "Insider";
export const PICKS_CAROUSEL_TITLE = "Magazine";
export const allowFullScreenVideo = true;
export const devicePlatform = "web";
export const disabledBanners = [];
export * from "./common";
